/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-15 17:38:33
 * @LastEditors: kevinqq 350910378@qq.com
 * @LastEditTime: 2025-03-20 20:53:03
 * @FilePath: \baishu_react_ui\src\Login\BsyRadioGroup\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import { BsyUtils } from '../../utils/Utils';
import BsyFileUpload from '../BsyFileUpload';
import './index.css';
import tipAlert from '../../Login/BsyAlertTip/Staticize';
import classNames from 'classnames';
import { BsyFormula } from '../../global/Formula';
import { dayjsUtils } from '../../utils/dayjsUtils';

import { ImageAddWatermark } from '../../utils/ImageAddWatermark';
import { getAfterSuffix } from '../../utils/getAfterSuffix';
class BsyImageUpload extends BsyFileUpload {

    static defaultProps = {
        baseCls: 'bsy-upload bsy-image-upload',
        type: 'image',
        files: [],
        uploadURL: '/upload',
        uploadTokenURL: '/file/upload_token',
        uploadToMedia: !1,
        fileType: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tif'],
        iconCls: 'icon-add1 ',
        uploadToForm: !0,
        compressed: !1,
        onlyCamera: !1,
        thumbWidth: 65,
        thumbHeight: 65,
        imageData: [],
        imageDataType: '',
        formMode: !1,
        watermarkSwitch: !1,
        watermarkPosition: 'bottomLeft',
        watermarkFieldTitle: true,
        watermarkSize: '14',
        watermarkColor: '#ffffff',
        watermarkField: {},
        watermarkFixedField: {},
        grid2: !1,
        hasProgress: !0,
        hasUploadBtn: !0
    };

    constructor(props) {
        super({
            ...props,

            uploadSite: window.FX.CONST.QN_BUCKET.UPLOAD_SITE || 'qn',
            fileType: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tif'],
            tipText: React.language('form.theme.image'),
            iconCls: 'icon-add1 ',
            maxFileTip: React.language('widget.file.maxCount',
                { num: props.maxFileCount })
        });
        this.inputKey = 0;
        if (!this.options.hasOwnProperty("browserCompress")) {
            this.options.browserCompress = this.options.compressed || false;
        }
    }

    componentDidMount() {
        super.componentDidMount();

    }

    _doDataUpload = () => {
        var a = this;
        var o = this.options;
        if (!BsyUtils.isFormDataSupported())
            return void tipAlert({
                type: 'warning',
                msg: React.language('upload.browserNotSupportTip')
            });

        var success = 0;
        var fail = 0;
        var c = {};

        var g = function (result) {

            if (success + fail === a.upFiles.length) {
                a.uploading = false;
                a.inputKey++;
                if (fail > 0) {

                    a.onFail({
                        failCount: fail,
                        result: result
                    });
                } else {
                    a.g_files = [...a.g_files, ...a.previewlist];

                    a.setState({}, () => {
                        a.onSuccess();
                    });
                }
            }

        };

        if (this.upFiles) {
            this.uploading = true;
            this.previewlist = new Array(this.upFiles.length);
            this.previewlist.fill({});

            this.setState({ ...this.state }, () => {

                BsyUtils.forEach(a.upFiles, function (h, orgj) {

                    BsyUtils.imageCompressed(orgj, o.browserCompress ? o.quality : 1,
                        (j) => {
                            a.watermark(j, function (res) {
                                j = res;
                                a._doXhrUpload(j, function (d) {
                                    c[h] = d;
                                    // a.onUpload(f(), b)
                                }, function (e) {

                                    c[h] = j.size;
                                    // a.onUpload(f(), b);
                                    let file = { ...e.file };
                                    let isok = true;
                                    if (!file.hasOwnProperty('error')) {
                                        // file.index = ggd;
                                        // a.files.push(file);
                                        a.previewlist[h] = file;
                                        isok = true;
                                        success++;
                                    } else {
                                        if (file.error > 7100) {
                                            BsyUtils.Vip.showUpgradeTip(file);
                                        } else {
                                            tipAlert({
                                                type: 'warning',
                                                msg: React.language(
                                                    'error.qiniu.violation', {
                                                    file: file.name
                                                })
                                            });
                                        }
                                        fail++;
                                        isok = false;
                                    }

                                    g(e, isok, file, h);
                                }, function (d) {
                                    c[h] = 0;
                                    // a.onUpload(f(), b);
                                    fail++;
                                    g(d, false, null, h);

                                    return !1;
                                });
                            });

                        });

                    // }
                });
            });
        }
    };

    watermark = (file, callback) => {

        var o = this.options;

        if (!o.watermarkSwitch) {
            callback && callback(file);
            return;
        }

        if (!file || !file.name) return false;
        var t = this;
        var o = this.options;
        // 这个是水印的图片
        var defaultsWatermark = {
            watermarkPosition: o.watermarkPosition,
            watermarkSize: o.watermarkSize,
            watermarkColor: o.watermarkColor,
            watermarkField: o.watermarkField
        };
        var strList = [];

        if (defaultsWatermark.watermarkField['location'] && window.AMap) {
            var locationValue = '';
            window.AMap.plugin('AMap.Geolocation', function () {
                var geolocation = new window.AMap.Geolocation({
                    // 是否使用高精度定位，默认：true
                    enableHighAccuracy: true,
                    // 设置定位超时时间，默认：无穷大
                    timeout: 10000,
                    // 定位按钮的停靠位置的偏移量
                    offset: [10, 20],
                    //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                    zoomToAccuracy: true,
                    //  定位按钮的排放位置,  RB表示右下
                    position: 'RB',
                    showButton: false
                });

                geolocation.getCurrentPosition(function (status, result) {
                    if (status == 'complete') {
                        onComplete(result);
                    } else {
                        onError(result);
                    }
                });

                function onComplete(data) {
                    // data是具体的定位信息
                    // console.log(data);
                    var MGeocoder;
                    window.AMap.plugin(['AMap.Geocoder'], function () { //回调函数
                        MGeocoder = new window.AMap.Geocoder({
                            radius: 100,
                            extensions: 'all'
                        });
                        MGeocoder.getAddress(data.position,
                            function (status, result) {
                                if (status === 'complete' && result.regeocode) {
                                    var city = result.regeocode.addressComponent.city;
                                    var detail = (result.regeocode.pois.length >
                                        0 ? result.regeocode.pois[0].address : '') +
                                        (result.regeocode.pois.length > 0
                                            ? result.regeocode.pois[0].name
                                            : '');
                                    var district = result.regeocode.addressComponent.district;
                                    var province = result.regeocode.addressComponent.province;
                                    locationValue = province + city + district +
                                        detail;
                                    var lnglat = [
                                        data.position.lng,
                                        data.position.lat];
                                    strList = t.addWatemarkData(locationValue,
                                        lnglat);
                                    t.createWatermark(file, callback, strList);
                                } else {
                                    console.error(React.language('latLon.not.exist'), status, result)
                                    tipAlert({
                                        type: 'error',
                                        msg: React.language('latLon.not.exist')
                                    });
                                }
                            });
                    });
                }

                function onError(data) {
                    // 定位出错
                    if (data.message ===
                        'Geolocation permission denied.Get ipLocation failed.') {
                        strList = t.addWatemarkData('', ['', '']);
                        t.createWatermark(file, callback, strList);
                    } else {
                        window.AMap.plugin('AMap.CitySearch', function () {
                            var citySearch = new window.AMap.CitySearch();
                            citySearch.getLocalCity(function (status, result) {
                                if (status === 'complete' && result.info ===
                                    'OK') {
                                    // 查询成功，result即为当前所在城市信息
                                    console.log(result);
                                    locationValue = result.province +
                                        result.city;
                                    var rectangle = result.rectangle.split(';');
                                    var firstRec = rectangle[0].split(',');
                                    var townRec = rectangle[1].split(',');
                                    var newRec = [];
                                    newRec.push(Number(firstRec[0]) +
                                        (Number(townRec[0]) -
                                            Number(firstRec[0])) / 2);
                                    newRec.push(Number(firstRec[1]) +
                                        (Number(townRec[1]) -
                                            Number(firstRec[1])) / 2);
                                    strList = t.addWatemarkData(locationValue,
                                        newRec);
                                    t.createWatermark(file, callback, strList);
                                }
                            });
                        });
                    }
                }
            });

        } else {
            strList = t.addWatemarkData('');
            t.createWatermark(file, callback, strList);
        }
    };
    addWatemarkData = (locationValue, lnglat) => {
        var strList = [];
        var t = this;
        var o = this.options;
        var formdata = BsyUtils.applyFunc(t, o.onGetFormData, [], !1);
        BsyUtils.forEach(o.watermarkField, function (key, res) {
            var s = (res.newText || res.text) + '：';
            if (!o.watermarkFieldTitle) {
                s = '';
            }
            if (res.value === 'time') {
                strList.push(
                    s + BsyUtils.date2Str(dayjsUtils.timeToTZ(new Date()), 'yyyy-MM-dd HH:mm:ss'));
            } else if (res.value === 'creator') {
                window.FX.STATIC.user &&
                    strList.push(s + window.FX.STATIC.user.nickname);
            } else if (res.value === 'location') {
                strList.push(s + locationValue);
                if (lnglat) {
                    if (!o.watermarkFieldTitle) {
                        strList.push(lnglat[0]);
                        strList.push(lnglat[1]);
                    } else {
                        strList.push(React.language('lon') + lnglat[0]);
                        strList.push(React.language('lat') + lnglat[1]);
                    }
                }

            } else {
                if (res.value.indexOf('.') > -1) {
                    var subformWidgetName = res.value.split('.')[0];
                    var subformIndex = o.renderBtn.element.parent().
                        parent().
                        index();
                    if (res.type === 'textarea') {
                        if (formdata[subformWidgetName][subformIndex]) {
                            var areaData = formdata[subformWidgetName][subformIndex][res.value.split(
                                '.')[1]].data.split('\n');
                            BsyUtils.forEach(areaData, function (key1, res1) {
                                if (key1 === 0) {
                                    strList.push(s + res1);
                                } else {
                                    strList.push(res1);
                                }
                            });
                        } else {
                            strList.push(s);
                        }
                    } else {
                        if (formdata[subformWidgetName][subformIndex]) {
                            strList.push(s + t._createData(
                                formdata[subformWidgetName][subformIndex][res.value.split(
                                    '.')[1]].data, res));
                        } else {
                            strList.push(s);
                        }
                    }

                } else {
                    if (res.type === 'textarea') {
                        if (formdata[res.value]) {
                            var areaData = formdata[res.value].split('\n');
                            BsyUtils.forEach(areaData, function (key1, res1) {
                                if (key1 === 0) {
                                    strList.push(s + res1);
                                } else {
                                    strList.push(res1);
                                }
                            });
                        } else {
                            strList.push(s);
                        }
                    } else {
                        strList.push(
                            s + t._createData(formdata[res.value], res));
                    }
                }
            }
        });
        var n = [];
        BsyUtils.forEach(strList, function (key, res) {
            if (res) {
                n.push(res);
            }
        });
        return n;
    };
    _getTextFromUserCell = (e) => {
        if (window.$.isPlainObject(e)) {
            return BsyUtils._toDeptUser(e, 'user');
        } else {
            return e;
        }
    };
    _createData = (e, i) => {
        var a = this;

        var n = {
            text: ''
        };

        if (BsyUtils.isObjectEmpty(e))
            return n.text;
        switch (i.type) {
            case 'checkboxgroup':
            case 'combocheck':
            case 'array':
                n.text = BsyUtils.isNull(e) ? '' : e.join(', ');
                break;
            case 'radiogroup':
            case 'combo':
                if ('creator' === i.field) {
                    n.text = this._getTextFromUserCell(e);
                    break;
                } else
                    n.text = e;
                break;
            case 'string':
            case 'text':
                if ('creator' === i.field) {
                    n.text = this._getTextFromUserCell(e);
                    break;
                } else {
                    n.text = e;
                }

                break;
            case 'textarea':
                n.text = e;
                break;
            case 'id':
            case 'did':
            case 'user':
            case 'dept':
                if (i.type === 'user' && i.name === 'creator') {
                    if (e.avatarurl) {
                        n.html = window.$(
                            '<img src=' + e.avatarurl + ' /><span> ' +
                            this._getTextFromUserCell(window.userSelectMap[e]
                                ? window.userSelectMap[e]
                                : e) + ' </span>');
                        n.text = this._getTextFromUserCell(
                            window.userSelectMap[e]
                                ? window.userSelectMap[e]
                                : e);
                    } else {
                        const bg = this._getTextFromUserCell(
                            window.userSelectMap[e]
                                ? window.userSelectMap[e]
                                : e) ? BsyUtils.formatUserThumb(
                                    this._getTextFromUserCell(window.userSelectMap[e]
                                        ? window.userSelectMap[e]
                                        : e).toString()) : '';
                        n.html = window.$(
                            '<div class="table-user-portrait-name color-' +
                            bg.color + '"><span>' + bg.name +
                            '</span></div><span> ' +
                            this._getTextFromUserCell(e) + ' </span>');
                        n.text = this._getTextFromUserCell(
                            window.userSelectMap[e]
                                ? window.userSelectMap[e]
                                : e);
                    }
                } else {
                    if (i.type === 'user')
                        n.text = this._getTextFromUserCell(
                            window.userSelectMap[e]
                                ? window.userSelectMap[e]
                                : e);
                    else {
                        n.text = this._getTextFromUserCell(
                            window.deptSelectMap[e]
                                ? window.deptSelectMap[e]
                                : e);
                    }
                }
                break;
            case 'usergroup':
            case 'deptgroup':
                var o = [];
                BsyUtils.forEach(e, function (t, e) {
                    let val = i.type === 'usergroup' ? (window.userSelectMap[e]
                        ? window.userSelectMap[e]
                        : e) : (window.deptSelectMap[e]
                            ? window.deptSelectMap[e]
                            : e);
                    o.push(a._getTextFromUserCell(val));
                });
                n.text = o.join(',');
                break;
            case 'formula':
            case 'number':
                // var r = FX.Utils.fixDecimalPrecision(e);
                // n.text = FX.Utils.num2Str(r, i.format);

                const res = BsyUtils.numberFormatValue(e, i || { 'format': i.format });
                const afterSuffixVal = getAfterSuffix(i.afterSuffix)
                if (afterSuffixVal && res.text && !res.text.includes("%")) {
                    res.text =  res.text + ' ' + afterSuffixVal;
                } 
                n.text = res.text;
                break;
            case 'address':
            case 'location':
                var l = [];
                if (e.province) {
                    l.push(e.province);
                    e.city && e.province !== e.city && l.push(e.city);
                    e.district && l.push(e.district);
                }

                // e.province && (l.push(e.province),
                //     e.city && e.province !== e.city && l.push(e.city),
                //     e.district && l.push(e.district)),
                e.detail && l.push(e.detail);
                n.text = BsyUtils.address2Str(e, i.format);
                break;
            case 'datetime':
                n.text = BsyUtils.date2Str(dayjsUtils.timeToTZ(e), i.format);
                break;
            case 'linkdata':
                var d = e && e.key;
                if (BsyUtils.isNull(d))
                    break;
                'datetime' === i.linkType ? n.text = BsyUtils.date2Str(
                    dayjsUtils.timeToTZ(d), 'yyyy-MM-dd') : n.text = d;
                if ('number' === i.linkType) {
                    const res = BsyUtils.numberFormatValue(d, i);
                    const afterSuffixVal = getAfterSuffix(i.afterSuffix)
                    if (afterSuffixVal && res.text && !res.text.includes("%")) {
                      res.text =  res.text + ' ' + afterSuffixVal;
                    } 
                    n.text = res.text;
                }
                break;
            case 'flowState':
            case 'flowstate':
                var u = window.FX.CONST.WORKFLOW.FLOWSTATE,
                    h = {};
                h[u.INPROCESS] = React.language('flow.state.inProcess');
                h[u.COMPLETE] = React.language('flow.state.complete');
                h[u.CLOSE] = React.language('flow.state.closed');
                n.text = h[e];
                break;
            case 'flowdecision':
            case 'flowDecision':
                var e1 = {};
                e1[0] = React.language('filter.method.ep');
                e1[1] = React.language('approved');
                e1[2] = React.language('approval.rejected');
                if (e) {
                    if (e.state_id) {
                        n.text = e.state;
                        break;
                    }
                }
                n.text = e1[e];
                break;
            case 'chargers':
                var p = {},
                    f = {};
                BsyUtils.forEach(e, function (t, e) {

                    if (e.flowName) {
                        p[e.flowName] || (p[e.flowName] = !0);
                        f[e.userNickname] || (f[e.userNickname] = !0);
                    }

                    // e.flowName && (p[e.flowName] || (p[e.flowName] = !0),
                    //     f[e.userNickname] || (f[e.userNickname] = !0))
                });
                var m = [];
                'node' === i.show ? BsyUtils.forEach(p, function (t) {
                    m.push(t);
                }) : BsyUtils.forEach(f, function (t) {
                    m.push(t);
                });
                n.text = m.join(',');
                break;
            case 'phone':
                if (e && e.phone) {
                    n.text = e.phone;
                } else {
                    n.text = '';
                }
                break;
            default:
                n.text = e;
        }

        return n.text;
    };
    createWatermark = (file, callback, strList) => {
        ImageAddWatermark(file, {
            content: strList,
            color: this.options.watermarkColor,
            location: this.options.watermarkPosition
        }).then(callback);
    };
 

    createQr = (e) => {

        var b = this,
            c = this.options;
        var _this = this;
        var _options = this.options;

        var formdata = BsyUtils.applyFunc(b, c.onGetFormData, [], !1);
        console.log(formdata);
        _this.lastID = _this.socketUUUID;
        _this.socketUUUID = BsyFormula.MD5(BsyUtils.UUID());
        var url = window.location.protocol + '//' + window.location.host +
            window.rootDirectroy + '/dashboard/signatureprPad/' +
            _this.socketUUUID;

        console.log('扫码地址' + url);
        var pane = window.$(e.target);
        window.FX.WebSocket.on(_this.socketUUUID, _this.lastID, {
            expTime: _options.timeout || 60 * 10,
            widgetName: _options.widgetName,
            widgetType: 'image',
            maxFileCount: _options.maxFileCount,
            onlyCamera: _options.onlyCamera,
            compressed: _options.compressed,
            wxOriginalComponent: _options.wxOriginalComponent,
            maxFileSize: _options.maxFileSize,
            nickname: window.FX.STATIC.user
                ? window.FX.STATIC.user.nickname
                : '',
            formdata: formdata,
            watermarkSwitch: _options.watermarkSwitch,
            watermarkAddPhoto: _options.watermarkAddPhoto,
            watermarkPosition: _options.watermarkPosition,
            watermarkFieldTitle: _options.watermarkFieldTitle,
            watermarkSize: _options.watermarkSize,
            watermarkColor: _options.watermarkColor,
            watermarkField: _options.watermarkField,
            subformZindex: _options.renderBtn
                ? _options.renderBtn.element.parent().parent().index()
                : 0,
            onCreateQR: function () {
                window.$('.bby-msg-bubble.qr').length > 0 &&
                    window.$('.bby-msg-bubble.qr').remove();
                b.qrbubble = window.FX.Utils.createQrcodeDropDown(pane, url,
                    React.language('scan.qr.image'));
            },
            onConnect: function () {
                if (b.qrbubble) {
                    b.qrbubble.element.remove();
                }
            },
            onStopEdit: function (i) {
                //手动写图完成触发事件
                // _this.setValue(i);
                console.log(i);
                if (i.isDelete) {
                    var n = b.g_files.length;
                    var r = -1;
                    for (var jc = 0; jc < n; jc++) {
                        if (i._id === b.g_files[jc]._id) {
                            r = jc;
                        }
                    }
                    if (r > -1) {
                        b.g_files.splice(r, 1);
                        // b.$previewList.find('.upload-info:eq(' + r + ')').remove();
                        b.setState({}, () => {
                            BsyUtils.applyFunc(b, c.onFileRemove, [r], !1);
                            BsyUtils.applyFunc(b, c.onStopEdit,
                                [b.g_files, null, b], !1);
                        });
                        return;
                    }

                } else {
                    if (_options.maxFileCount == 1) {
                        // b.$previewList.empty();
                        b.g_files = [i];
                    } else {
                        if (b.g_files.length >= c.maxFileCount) {
                            tipAlert({
                                msg: c.maxFileTip,
                                type: 'warning'
                            });
                            return;
                        }
                        b.g_files.push(i);
                    }
                }
                b.setState({}, () => {
                    BsyUtils.applyFunc(b, c.onStopEdit, [b.g_files, null, b],
                        !1);
                });
            }
        });
        if (window.FX.WebSocket.socket) {
            window.$('.bby-msg-bubble.qr').length > 0 &&
                window.$('.bby-msg-bubble.qr').remove();
            window.FX.Utils.createQrcodeDropDown(pane, url,
                React.language('scan.qr.image'));
        }
    };

    drawImage = (img) => {
        var imgWidth = img.naturalWidth;
        var imgHeight = img.naturalHeight;
        img.style.width = '';
        img.style.height = '';
        img.style.display = 'flex';
        if (imgWidth > imgHeight) {
            if (imgWidth > 130) {
                img.style.width = '100%';
            } else {
                img.style.height = 'auto';
            }
        } else {
            if (imgHeight > 130) {
                img.style.height = '100%';
            } else {
                img.style.height = 'auto';
            }
        }

    };

    renderFileItem = (file, index) => {
        if (!file || !file.qnKey) {
            return <div key={file._id} className="upload-info">
                <div className="loading">
                    <div className="node"></div>
                    <div className="node"></div>
                    <div className="node"></div>
                    <div className="node"></div>
                    <div className="node"></div>
                    <div className="node"></div>
                    <div className="node"></div>
                    <div className="node"></div>
                </div>
            </div>;
        } else {
            var s = BsyUtils.byteFormat2(file.size);
            var n = this._trimFileName(file.name);

            return <div key={file._id} className="upload-info">
                <div className="upload-preview"

                    onClick={() => {
                        this.previewFile(file, index);
                    }}
                >
                    <img src={BsyUtils.getfiledownloadURL(file,
                        { mode: 2, width: 130, height: 130 })} alt=""
                        onLoad={() => {
                            // this.drawImage(e.currentTarget || e.target)
                        }}
                    />
                </div>
                <div className="upload-file-info"
                    onClick={() => {
                        this.previewFile(file, index);
                    }}
                >
                    <div className="info-text" title={n}>{n}</div>
                    <div className="info-sub">{s}</div>
                </div>
                <div className="upload-info-btn remove-btn"
                    onClick={() => { this.deleteFile(file); }}>
                    <i className="icon-bby-quchu"></i>
                </div>
            </div>;
        }
    };

    renderBody = () => {
        // console.log('previewlist', this.previewlist);
        // console.log('g_files', this.g_files);
        const { cssName, uploadURL, fileType, maxFileCount } = this.options;
        var d = '.' + fileType.join(',.');
        if (!this.g_files) {
            this.g_files = [];
        }
        if (!this.previewlist) {
            this.previewlist = [];
        }
        if (cssName.indexOf('subform') == -1) {
            return <>
                <div className={'upload-preview-list' + (this.g_files.length === 0 && this.previewlist.length === 0 ? " empty" : "")}>
                    {
                        this.g_files.map((file, index) => {
                            return this.renderFileItem(file, index);
                        })
                    }
                    {
                        this.previewlist.map((file, index) => {
                            return this.renderFileItem(file, index);
                        })
                    }
                    {
                        this.isEnabled() ?
                            <div className={classNames('upload-btn image',
                                this.options.onlyCamera && 'upload-disabled')}>
                                <div className={'upload'}>
                                    <i className="icon-add1 upload-icon"></i>
                                    <span>{React.language(
                                        'image.select')}</span>
                                    <form className="upload-form"
                                        action={uploadURL}
                                        key={'formk' + this.inputKey}
                                        enctype="multipart/form-data"
                                        method="post">
                                        <input
                                            disabled={this.options.onlyCamera}
                                            type="file" name="file"
                                            className="upload-btn-input"
                                            accept={d}
                                            ref={this.$uploadInput}
                                            onChange={this.onChange}
                                            multiple={maxFileCount > 1}
                                        />
                                    </form>
                                </div>
                                {!this.options.onlyCamera &&
                                    <div className="qr_upload"
                                        onClick={this.createQr}
                                    >
                                        <div className="qsbtv"><i
                                            className="icon-qrcode"></i><a>{React.language(
                                                'phone.code.qr.tip')}</a></div>
                                    </div>}
                            </div> : null
                    }
                    {this.options.onlyCamera && <span
                        className="upload-tip">{React.language("widget.image.onlyCameraTip")}</span>}
                </div>
            </>;
        } else {
            return <>
                <div className={classNames('upload-btn image',
                    this.options.onlyCamera && 'upload-disabled')}>
                    <div className={'upload'}>
                        <i className="icon-add1 upload-icon"></i>
                        <span>{React.language('image.select')}</span>
                        <form className="upload-form" action={uploadURL}
                            key={'formk' + this.inputKey}
                            enctype="multipart/form-data"
                            method="post">
                            <input type="file" name="file"
                                disabled={this.options.onlyCamera}
                                className="upload-btn-input" accept={d}
                                ref={this.$uploadInput}
                                onChange={this.onChange}
                                multiple={maxFileCount > 1 ? true : false}
                            />
                        </form>
                    </div>
                    {!this.options.onlyCamera && <div className="qr_upload"
                        onClick={this.createQr}
                    >
                        <div className="qsbtv"><i
                            className="icon-qrcode"></i><a>{React.language(
                                'phone.code.qr.tip')}</a></div>
                    </div>}
                </div>
                <div className={'upload-preview-list' + (this.g_files.length === 0 && this.previewlist.length === 0 ? " empty" : "")}>
                    {
                        this.g_files.map((file, index) => {
                            return this.renderFileItem(file, index);
                        })
                    }
                    {
                        this.previewlist.map((file, index) => {
                            return this.renderFileItem(file, index);
                        })
                    }
                </div>
                {this.options.onlyCamera && <span
                    className="upload-tip">{React.language(
                        'widget.image.onlyCameraTip')}</span>}
            </>;
        }
    };

    render() {

        const { cssName, download } = this.options;

        if (!this.isEnabled() && BsyUtils.isObjectEmpty(this.g_files)) {
            return this.renderDisablePane('');
        }
        return (
            <div className={cssName}
                ref={this.element}
            >

                {
                    this.renderBody()
                }
                {
                    download && !BsyUtils.isObjectEmpty(this.g_files) ? <div
                        className={'download'} onClick={() => {
                            // this._package()
                            BsyUtils._package('', this.getValue(), this.options);
                        }}><i className={'icon-download'}></i>{React.language(
                            'Form.download')}</div> : ''
                }
            </div>
        );
    }
}

export default BsyImageUpload;
